import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=a3104bf6&scoped=true&"
import script from "./Donate.vue?vue&type=script&lang=js&"
export * from "./Donate.vue?vue&type=script&lang=js&"
import style0 from "./Donate.vue?vue&type=style&index=0&id=a3104bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3104bf6",
  null
  
)

export default component.exports